(() => {
  if (window.mdnmdEditorialV7) return;
  window.mdnmdEditorialV7 = true;
  let scheduled = false;
  let observer;
  const visible = (node) => node && node.getClientRects().length && getComputedStyle(node).display !== 'none';
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; syncOverlay(); });
  }
  function syncOverlay() {
    // Restore normal flow before measuring. No theme-specific hard-coded header height.
    document.querySelectorAll('.mde-overlay-campaign').forEach((section) => {
      section.classList.remove('mde-overlay-campaign');
      section.style.removeProperty('--mde-header-clearance');
    });
    document.querySelectorAll('[data-mde-overlay-active]').forEach((node) => node.removeAttribute('data-mde-overlay-active'));
    const nav = document.querySelector('mdnmd-navigation[data-overlay-enabled="true"]');
    const main = document.querySelector('#MainContent') || document.querySelector('main');
    if (!visible(nav) || !main) return;
    const firstSection = [...main.querySelectorAll('.shopify-section')].find(visible);
    const hero = firstSection?.querySelector('mdnmd-campaign[data-overlay-hero="true"]');
    if (!hero) return;
    const navSection = nav.closest('.shopify-section');
    if (!navSection) return;
    nav.setAttribute('data-mde-overlay-active', '');
    let firstHeader = navSection;
    const announcement = document.querySelector('[data-mde-announcement][data-overlay-enabled="true"]');
    const announcementSection = visible(announcement) ? announcement.closest('.shopify-section') : null;
    const navRect = navSection.getBoundingClientRect();
    if (announcementSection) {
      const rect = announcementSection.getBoundingClientRect();
      if (rect.top <= navRect.top && Math.abs(rect.bottom - navRect.top) < 3) firstHeader = announcementSection;
    }
    const heroRect = firstSection.getBoundingClientRect();
    // Fail safely with a solid header if another section separates navigation and hero.
    if (Math.abs(heroRect.top - navRect.bottom) > 3) { nav.removeAttribute('data-mde-overlay-active'); return; }
    const offset = Math.round(heroRect.top - firstHeader.getBoundingClientRect().top);
    if (offset <= 0 || offset > 500) { nav.removeAttribute('data-mde-overlay-active'); return; }
    firstSection.style.setProperty('--mde-header-clearance', `${offset}px`);
    firstSection.classList.add('mde-overlay-campaign');
    nav.setAttribute('data-mde-overlay-active', '');
    if (firstHeader === announcementSection) announcement.setAttribute('data-mde-overlay-active', '');
  }
  function observeLayout() {
    observer?.disconnect();
    observer = new ResizeObserver(schedule);
    document.querySelectorAll('mdnmd-navigation, [data-mde-announcement]').forEach((node) => observer.observe(node));
    schedule();
  }
  if (!customElements.get('mdnmd-navigation')) {
    customElements.define('mdnmd-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('toggle', (event) => {
          if (event.target.matches('details[data-mde-menu]')) {
            if (event.target.open) this.closeMenus(event.target);
            else { event.target.querySelectorAll('.mde-category.is-open').forEach(item => { this.setCategory(item, false); }); const panel = event.target.querySelector('.mde-menu-panel'); if (panel) this.setMode(panel, panel.dataset.initialMode || 'custom'); }
          }
          this.syncSurface();
        }, { ...options, capture: true });
        const highlight = (event) => {
          const choice = event.target.closest('[data-mde-mode-choice]');
          const panel = choice?.closest('.mde-menu-panel');
          if (panel) this.setMode(panel, choice.dataset.mdeModeChoice);
        };
        this.addEventListener('pointerover', (event) => { if (event.pointerType !== 'touch') highlight(event); }, options);
        this.addEventListener('focusin', highlight, options);
        this.addEventListener('click', (event) => {
          // Keep theme-level delegated menu handlers from treating these controls as their own.
          if (event.target.closest('details[data-mde-menu]')) event.stopPropagation();
          if (event.target.closest('[data-mde-mode-button]')) highlight(event);
          const toggle = event.target.closest('[data-mde-category-toggle]');
          if (toggle) {
            const category = toggle.closest('.mde-category');
            const expand = !category.classList.contains('is-open');
            category.closest('[data-mde-menu-content]')?.querySelectorAll('.mde-category').forEach(item => this.setCategory(item, item === category && expand));
          }
        }, options);
        this.querySelectorAll('[data-mde-mode-button]').forEach(button => { button.disabled = false; });
        this.querySelectorAll('.mde-menu-panel').forEach(panel => this.setMode(panel, panel.dataset.initialMode || 'custom'));
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const category = this.querySelector('[data-mde-menu-content]:not([hidden]) .mde-category.is-open');
          if (category) { this.setCategory(category, false); category.querySelector('[data-mde-category-toggle]').focus(); return; }
          const open = this.querySelector('details[data-mde-menu][open]');
          if (open) { open.open = false; open.querySelector('summary').focus(); }
        }, options);
        document.addEventListener('click', (event) => { if (!this.contains(event.target)) this.closeMenus(); }, options);
        // Safari may blur a summary without focusing the clicked button. A null
        // focus destination is not an outside interaction: wait for real focusin.
        document.addEventListener('focusin', (event) => {
          if (!this.contains(event.target)) this.closeMenus();
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const blockId = event.detail?.blockId;
          if (!blockId) return;
          const block = this.querySelector(`[data-mde-block="${CSS.escape(blockId)}"]`);
          const disclosure = block?.closest('details') || block?.querySelector('details');
          if (disclosure) { this.closeMenus(disclosure); disclosure.open = true; }
        }, options);
        schedule();
      }
      setMode(panel, mode) {
        if (!['ready', 'custom'].includes(mode)) return;
        const activeCategory = panel.querySelector('[data-mde-menu-content]:not([hidden]) .mde-category.is-open')?.dataset.categoryKey;
        const changed = panel.dataset.mdeMode !== mode;
        panel.dataset.mdeMode = mode;
        panel.querySelectorAll('[data-mde-mode-button]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.closest('[data-mde-mode-choice]').dataset.mdeModeChoice === mode));
        });
        panel.querySelectorAll('[data-mde-menu-content]').forEach(content => {
          content.hidden = content.dataset.mdeMenuContent !== mode;
          if (changed) content.querySelectorAll('.mde-category').forEach(category => { this.setCategory(category, !content.hidden && category.dataset.categoryKey === activeCategory); });
        });
        const status = panel.querySelector('[data-mde-mode-status]');
        const message = mode === 'ready' ? 'Ready-to-Wear collections' : 'Custom Order collections';
        if (status && status.textContent !== message) status.textContent = message;
      }
      setCategory(category, open) {
        category.classList.toggle('is-open', open);
        category.querySelector('[data-mde-category-toggle]').setAttribute('aria-expanded', String(open));
        category.querySelector('.mde-subcollections').hidden = !open;
      }
      syncSurface() {
        const open = !!this.querySelector('details[data-mde-menu][open]');
        this.toggleAttribute('data-mde-menu-open', open);
        const announcement = this.closest('.shopify-section')?.previousElementSibling?.querySelector('[data-mde-announcement]');
        if (this.announcement && this.announcement !== announcement) this.announcement.removeAttribute('data-mde-menu-open');
        this.announcement = announcement;
        if (announcement) {
          const style = getComputedStyle(this);
          ['--mde-menu-surface', '--mde-menu-blur'].forEach(key => announcement.style.setProperty(key, style.getPropertyValue(key)));
          announcement.toggleAttribute('data-mde-menu-open', open);
        }
      }
      closeMenus(except) {
        this.querySelectorAll('details[data-mde-menu][open]').forEach((menu) => { if (menu !== except) { menu.open = false; menu.querySelectorAll('.mde-category.is-open').forEach(category => { this.setCategory(category, false); }); const panel = menu.querySelector('.mde-menu-panel'); if (panel) this.setMode(panel, panel.dataset.initialMode || 'custom'); } });
      }
      disconnectedCallback() { this.controller?.abort(); this.announcement?.removeAttribute('data-mde-menu-open'); schedule(); }
    });
  }
  if (!customElements.get('mdnmd-campaign')) {
    customElements.define('mdnmd-campaign', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const video = this.querySelector('video');
        const button = this.querySelector('.mde-video-toggle');
        if (video && button) {
          this.video = video;
          const reduced = matchMedia('(prefers-reduced-motion: reduce)');
          const update = () => {
            button.textContent = video.paused ? 'Play video' : 'Pause video';
            button.setAttribute('aria-label', video.paused ? 'Play campaign video' : 'Pause campaign video');
          };
          const play = () => video.play().catch(update);
          video.muted = true;
          video.controls = false;
          button.hidden = false;
          video.addEventListener('play', update, options);
          video.addEventListener('pause', update, options);
          video.addEventListener('error', () => { button.hidden = true; video.controls = true; }, options);
          button.addEventListener('click', () => { if (video.paused) play(); else video.pause(); }, options);
          reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); }, options);
          this.visibilityObserver = new IntersectionObserver(([entry]) => {
            if (!entry.isIntersecting) video.pause();
          });
          this.visibilityObserver.observe(this);
          update();
          if (this.dataset.autoplay === 'true' && !reduced.matches) play();
        }
        schedule();
      }
      disconnectedCallback() {
        this.controller?.abort(); this.visibilityObserver?.disconnect(); this.video?.pause(); schedule();
      }
    });
  }
  document.addEventListener('shopify:section:load', observeLayout);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(observeLayout));
  document.addEventListener('shopify:section:reorder', observeLayout);
  window.addEventListener('resize', schedule);
  window.addEventListener('load', observeLayout, { once: true });
  document.fonts?.ready.then(schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeLayout, { once: true });
  else observeLayout();
})();
